import { storePromotion } from "@/stores/promotion.js";
import { storeShippingFee } from "@/stores/shipping_fee.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function (path, query, type, perPage = storePromotion.perPage) {
    await $axios
      .post("/api/admin/promotion_get.php", { query: query, perPage: perPage, type: type })
      .then(function (res) {
        if (res.data.result == "pass") {
          if (type != "shipping_fee") {
            storePromotion.promotions = res.data.promotions;
            storePromotion.page = res.data.page;
            storePromotion.pageCount = res.data.page_count;
            if (JSON.stringify(query) != "{}" && query !== undefined) {
              if (query.page !== undefined) {
                if (parseInt(query.page) !== parseInt(res.data.page)) {
                  let cloneQuery = JSON.parse(JSON.stringify(query));
                  cloneQuery.page = parseInt(res.data.page);
                  router.replace({ path: path, query: cloneQuery });
                }
              }
            }
          } else {
            storeShippingFee.events = res.data.promotions;
            storeShippingFee.page = res.data.page;
            storeShippingFee.pageCount = res.data.page_count;
            if (JSON.stringify(query) != "{}" && query !== undefined) {
              if (query.page !== undefined) {
                if (parseInt(query.page) !== parseInt(res.data.page)) {
                  let cloneQuery = JSON.parse(JSON.stringify(query));
                  cloneQuery.page = parseInt(res.data.page);
                  router.replace({ path: path, query: cloneQuery });
                }
              }
            }
          }
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
